module.exports = "<button\n  class=\"ladda-button btn {{ generateReportCtrl.elementClasses }}\"\n  data-style=\"slide-left\"\n  ladda=\"generateReportCtrl.laddaBtn\"\n  ng-click=\"generateReportCtrl.generateReport()\"\n  type=\"button\"\n>\n  {{generateReportCtrl.reportName || 'Generate Report'}}\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/generateReports/template.btn.html
// module id = 1357
// module chunks = 0